import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MessageBoxType } from '@component/message-box';
import { ModalActions, ModalActionType } from '@component/modal';

export interface ConfirmationModalData {
  cancelButtonLabel?: string;
  destructive?: boolean;
  infoMessage?: string;
  message: string;
  position?: string;
  positiveButtonLabel: string;
  title: string;
  verificationString?: string;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-confirmation-modal',
  styleUrls: ['./confirmation-modal.component.scss'],
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements OnInit {
  messageBoxType = MessageBoxType;
  modalActions: ModalActions;
  userInputForVerification: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationModalData,
    private dialogRef: MatDialogRef<ConfirmationModalComponent>
  ) {}

  ngOnInit() {
    if (!this.data.position && this.data.infoMessage) this.data.position = 'top';
    this.setModalActions();
  }

  get verificationIsValid(): boolean {
    if (!this.data.verificationString) return true;
    return this.data.verificationString === this.userInputForVerification;
  }

  setModalActions(): void {
    this.modalActions = [
      {
        action: (): void => this.dialogRef.close(false),
        label: this.data.cancelButtonLabel || 'Cancel',
        type: ModalActionType.Close
      },
      {
        action: (): void => this.dialogRef.close(true),
        label: this.data.positiveButtonLabel,
        type: this.data.destructive ? ModalActionType.Destructive : ModalActionType.Positive
      }
    ];
  }
}
